<template>
    <div :class="['boardMember', member.row]">
        <div class="avatar">
            <Image :image="member.avatar" :width="160" :height="160" :mobileWidth="160" :mobileHeight="160" imageClass="cover" />
        </div>
        <div class="info">
            <div class="name bodyL">{{ member.name }}</div>
            <div class="role_eic">{{ member.role_eic }}</div>
            <div class="role_external">{{ member.role_external }}</div>
            <div class="country">{{ member.country }}</div>
        </div>
        <div class="link" v-if="member.link_linkedin">
            <a :href="member.link_linkedin">
                <IconLinkedin />
            </a>
        </div>
    </div>
</template>

<script lang="ts" setup>
defineProps<{ member: any }>()
</script>

<style lang="scss" scoped>
.boardMember {
    padding-left: var(--size-gutter-default);
    border-left: var(--size-thickness) solid var(--color-primary);

    display: grid;
    grid-template-rows: min-content 1fr min-content;
    gap: var(--size-gutter-default);

    .avatar {
        position: relative;
        width: 100%;
        max-width: 160px;
        aspect-ratio: 1;
        border-radius: 50%;
        overflow: hidden;
    }

    .info {
        width: 100%;
        max-width: 160px;
        display: flex;
        flex-direction: column;
        gap: 4px;
        text-wrap: balance;

        .name {
            font-weight: bold;
        }

        .role_eic {
            font-weight: bold;
            color: var(--color-primary);
        }

        .role_external {
            text-wrap: balance;
        }

        .country {
            font-size: 14px;
            text-transform: uppercase;
        }
    }

    .link {
        a {
            display: inline-block;
        }

        svg {
            display: block;
        }
    }

    &.president {
        grid-column: span 2;
    }
}

@media screen and (max-width: 600px) {
    .boardMember {

        display: flex;
        flex-direction: row;
        padding-inline: 0;
        border-left: 0;
        border-bottom: var(--size-thickness) solid var(--color-primary);
        padding-block: var(--size-gutter-default);

        .avatar {
            position: relative;
            width: 100%;
            max-width: 160px;
            max-height: 160px;
            aspect-ratio: 1;
            border-radius: 50%;
            overflow: hidden;
        }

        .link {
            margin-left: auto;
        }

    }
}
</style>